import React from 'react';
import { Button } from '@mui/material';
import { IOrderState, ITransportState, TransportTypeEnum, useAppState } from '../../states/app-state';
import { analytics, TTransportOption } from '../../api/bearer-api';
import { observer } from 'mobx-react-lite';
import TransportTypeImage from './TransportTypeImage';
// import LoginPopup from '../login/LoginPopup'; // commented by Bearer Web Developer
import DisabledClickLoading from '../../components/DisabledClickLoading';
import { error } from '../../app/log'; // added by Bearer Web Developer
import styles from './TransportsEditor.module.scss'; // added by Bearer Web Developer
import { logEvent } from 'firebase/analytics'; // added by Bearer Web Developer
import ReactPixel from 'react-facebook-pixel'; // added by Bearer Web Developer
import klaviyo from '../../states/klaviyo'; // added by Bearer Web Developer
import { useThemeMode } from '../../states/contexts/theme'; // added by Bearer Web Developer
type TTransport = {
    type: TransportTypeEnum,
    option: TTransportOption | null | undefined,
}
// useStyles removed by Bearer Web Developer
const TransportsEditor: React.FC<{ transport: ITransportState }> = observer(({ transport }) => { // observer added by Bearer Web Developer

    const appState = useAppState();
    const selectedOrder = appState.selectedOrder!;
    const needToConfirm = selectedOrder?.needToConfirmMadeOfTransport; // added by Bearer Web Developer
    // removed by Bearer Web Developer (not needed, we need one Login Popup component for every where of app) start
    // const [logInPopupOpen, setLogInPopupOpen] = React.useState(false);

    // const handleLoginInPopupClose = () => {
    //     setLogInPopupOpen(false);
    // }
    // removed by Bearer Web Developer (not needed, we need one Login Popup component for every where of app) end
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const [loading, setLoading] = React.useState(false);
    const handleConfirm = async () => {
        // added by Bearer Web Developer start
        // Firebase Analytics Event Name Mode of Transport Chosen (Final)
        // App Event Mode of Transport Confirmed by User
        if (appState.selectedOrder?.selectedTransportOption) {
            logEvent(analytics, "selected_mode_of_transport", {
                mode_of_transport: appState.selectedOrder?.selectedTransportOption?.type
            });
        }
        // the following "AddToCart" (Facebook Ads default event)
        if (appState?.environmentCode === "PRODUCTION") {
            ReactPixel.trackSingle('3587653761499122', 'AddToCart'); // For tracking custom events.
        }
        // klaviyo event start
        await klaviyo.createEvent({
            email: appState?.profile?.email,
            event: "Add To Cart"
        });
        // klaviyo event end
        // added by Bearer Web Developer end
        // the following sign_up_stage condition added by Bearer Web Developer
        if (!appState.login.loggedin && appState?.createAccount?.sign_up_stage === 0) {
            appState.login.setOpen(true) // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
        } else {
            if (!loading) setLoading(true); // loading condition added by Bearer Web Developer
            const r = await appState.selectedOrder?.fetchTransport();
            setLoading(false);
            r && transport.setEditing(false);
            // added by Bearer Web Developer start
            if (r) {
                const { is_full_discount, fullDiscountUsedOnce, coupon_id } = appState?.fullDiscountAutomatically;
                if (is_full_discount && !fullDiscountUsedOnce) {
                    selectedOrder?.discount.setFullDiscountUser(true);
                    selectedOrder?.discount?.setDiscountValue({
                        coupon_id, transport_receivable_price: 0
                    });
                }
            }
            // added by Bearer Web Developer end
        }
    }

    // added by Bearer Web Developer start
    const getTransports = () => {
        let transports: { type: TransportTypeEnum, option: TTransportOption }[] = [];
        const vehicle_display_order = appState.selectedOrder?.vehicle_display_order;
        Object.values(TransportTypeEnum).map((vehicle: TransportTypeEnum) => {
            const option = selectedOrder.transportOptions[vehicle as TransportTypeEnum];
            if (option) transports.push({ type: vehicle, option });
        });
        if (vehicle_display_order) {
            // Sort transports based on the order of vehicle_display_order array
            return transports?.sort((a, b) => {
                const indexA = vehicle_display_order.indexOf(a?.type);
                const indexB = vehicle_display_order.indexOf(b?.type);
                return indexA - indexB;
            })
        } else return transports;
    }
    const [transports, setTransports] = React.useState<TTransport[]>(getTransports());
    const fetchPricingData = async () => {
        try {
            setLoading(true);
            const r = await appState.selectedOrder?.fetchPricing();

            if (r) {
                setTransports(getTransports())
                // automatic select transport added by Bearer Web Developer start
                const recommend_vehicle = appState.selectedOrder?.recommend_vehicle;
                if (recommend_vehicle && appState.login.loggedin && appState.selectedOrder?.autoSelectTransport) {
                    const selectedOption = getTransports().find(transport => (transport?.type === recommend_vehicle));
                    if (selectedOption?.type) {
                        selectedOrder.selectOption(selectedOption?.type);
                        await handleConfirm();
                    }
                }
                // automatic select transport added by Bearer Web Developer end
            }
            setLoading(false);
        } catch (err) {
            error(err) // modify by Bearer Web Developer
        }
    }
    //  modified by Bearer Web Developer start (sign_up_stage added)
    React.useEffect(() => {
        if (appState.login.loggedin || appState?.createAccount?.sign_up_stage > 0) {
            fetchPricingData();
        }
    }, [appState, appState.login.loggedin, appState?.createAccount?.sign_up_stage]);
    //  modified by Bearer Web Developer end (sign_up_stage added)
    // added by Bearer Web Developer end
    //  modified by Bearer Web Developer start
    return (
        <>
            {/* <LoginPopup open={logInPopupOpen} handleClose={handleLoginInPopupClose} /> */} {/* removed by Bearer Web Developer (not needed, we need one Login Popup component for every where of app) */}
            <div className={styles.root} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.header}>
                    <h2>Mode of Transport</h2>
                    <Button variant="text" disableRipple={true} className={styles.clear} onClick={() => selectedOrder.selectOption(null)}>Clear</Button>
                </div>
                <div className={styles.transports}>
                    {transports.map(transport => <TransportEditor key={transport.type} transport={transport} selectedOrder={selectedOrder} />)}
                </div>
                <div>
                    <Button
                        className={`${styles.confirm} ${needToConfirm ? styles.need_to_confirm : ''}`}
                        onClick={handleConfirm}
                        disabled={loading}
                        disableRipple={true}
                    >
                        Confirm
                    </Button>
                    {loading && <DisabledClickLoading />}
                </div>

            </div>
        </>
    );
    //  modified by Bearer Web Developer end
});
export default TransportsEditor;

const TransportEditor: React.FC<{ transport: TTransport, selectedOrder: IOrderState }> = observer(({ transport, selectedOrder }) => {

    const handleTransportTypeSelected = () => {
        selectedOrder.selectOption(transport.type);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const selected = selectedOrder.transportOptions.selectedOption === transport.type;
    // const disabled = transport.option === null // commented by Bearer Web Developer
    //  modified by Bearer Web Developer start (remove desabled options and show just enabled options)
    // added by Bearer Web Developer start
    const best_fit = transport?.type === selectedOrder?.recommend_vehicle
    const capitalizeFirstLetterMadeOfTransport = transport.type?.slice(0, 1).toLocaleUpperCase() + transport.type?.slice(1).toLocaleLowerCase();
    // added by Bearer Web Developer end
    return (
        <>
            {
                <div className={`${styles.transport} ${styles.transport_default} ${selected ? styles.transport_selected : ''}`} onClick={handleTransportTypeSelected}>
                    <div className={styles.info}>
                        <TransportTypeImage type={transport.type} orange={true} />  {/* orange property added by Bearer Web Developer */}
                        <div className={styles.time_and_type}>
                            <div>{capitalizeFirstLetterMadeOfTransport}</div>
                            {/* added by Bearer Web Developer start - for best_fit */}
                            {best_fit &&
                                (
                                    theme === "dark" ?
                                        <img src="/best-fit-orange.svg" alt="" width={46} height={12} /> :
                                        <img src="/best-fit.svg" alt="" width={46} height={12} />
                                )
                            }
                            {/* added by Bearer Web Developer end - for best_fit */}
                            <div >{transport.option?.time}</div>
                        </div>
                    </div>
                    <div className={styles.price}>{transport.option?.price ? ("$ " + transport.option?.price?.toString()?.split('~')[0]) : ''}</div>
                    {
                        transport.option?.price?.toString()?.split('~')[1] &&
                        <>
                            <div className={styles.price}>~</div>
                            <div className={styles.price}>
                                {transport.option?.price ? ("$ " + transport.option?.price?.toString()?.split('~')[1]) : ''}
                            </div>
                        </>
                    }
                </div>
            }
        </>
    )
    //  modified by Bearer Web Developer end
});

